import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCreditCard: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.83337H4C2.388 2.83337 1.5 3.72137 1.5 5.33337V10.6667C1.5 12.2787 2.388 13.1667 4 13.1667H12C13.612 13.1667 14.5 12.2787 14.5 10.6667V5.33337C14.5 3.72137 13.612 2.83337 12 2.83337ZM13.5 10.6667C13.5 11.718 13.0513 12.1667 12 12.1667H4C2.94867 12.1667 2.5 11.718 2.5 10.6667V7.16671H13.5V10.6667ZM13.5 6.16671H2.5V5.33337C2.5 4.28204 2.94867 3.83337 4 3.83337H12C13.0513 3.83337 13.5 4.28204 13.5 5.33337V6.16671ZM4.16667 10C4.16667 9.72404 4.39067 9.50004 4.66667 9.50004H6.66667C6.94267 9.50004 7.16667 9.72404 7.16667 10C7.16667 10.276 6.94267 10.5 6.66667 10.5H4.66667C4.39067 10.5 4.16667 10.276 4.16667 10Z"
      fill={color}
    />
  </svg>
);

export default IconCreditCard;
